import React from 'react';
import './header.css';
import profile from '../../assets/header.png';

const Header = () => {
  return (
    <div className='my__header section__padding' id='aboutme'>
      <div className='my__header-content'>
        <h1>Hi! I’m Matthew Gonzalez 👋</h1>
        <p>
        I am currently a Data Engineer at JPMorgan Chase, where I build large-scale ETL data pipelines powering critical revenue analytics. I'm looking for my next challenge at a fast-moving startup, sitting at the intersection of engineering and growth to help drive technical product adoption through experiments, demos, and deep-dives.
        </p>
      </div>
      <div className='my__header-image'>
        <img src={profile} alt='profile'/>
      </div>
    </div>
  )
}

export default Header